/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import cn from 'clsx';
import { ReactComponent as CheckCircle } from 'assets/icons/CheckCircle.svg';
import { ReactComponent as DotSvg } from 'assets/icons/New/Dot.svg';
import { ReactComponent as PlusSvg } from 'assets/icons/New/Plus.svg';
import { ReactComponent as TrashSvg } from 'assets/icons/New/Trash.svg';
import { ReactComponent as Trash1Svg } from 'assets/icons/New/Trash1.svg';
import { ReactComponent as DuplicateSvg } from 'assets/icons/New/Duplicate.svg';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/New/arrow-right-icon.svg';
import { ReactComponent as OtherFileSvg } from 'assets/icons/New/OtherFile.svg';
import { ReactComponent as ProductTestingSvg } from 'assets/icons/Nav/ProductTesting.svg';
import { ReactComponent as ProductManagementSvg } from 'assets/icons/Nav/ProductManagement.svg';
import { ReactComponent as RenameSvg } from 'assets/icons/New/FilterBar/Rename.svg';
import ColumnActions from 'components/Antd/Table/ColumnActions';
import { getMomentDate } from 'util/date';
import { ATooltip } from 'components/Antd';
import { ADD_CD_TAB_KEYS } from '../AddCDModal/constants';
import ExpiredIcon from '../ExpiredIcon';
import classes from './Block.module.scss';

const ICON_MAPPING = {
  [ADD_CD_TAB_KEYS.TEST]: <ProductTestingSvg />,
  [ADD_CD_TAB_KEYS.CERTIFICATE]: <ProductManagementSvg />,
  [ADD_CD_TAB_KEYS.OTHER]: <OtherFileSvg />,
};

const SubBlock = ({
  className,
  data,
  onAdd,
  onRemoveDataItem,
  onRemove,
  onComplete,
  onEdit,
  onDuplicate,
  onViewData,
  defaultExpand,
  onResetExpandDefault,
  simple,
}) => {
  const today = getMomentDate('', true).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const testRecords = (data?.testDataMaps || []).map((obj) => ({
    ...obj,
    dataType: ADD_CD_TAB_KEYS.TEST,
  }));
  const certificateRecords = (data?.certificateDataMaps || []).map((obj) => ({
    ...obj,
    dataType: ADD_CD_TAB_KEYS.CERTIFICATE,
  }));
  const otherRecords = (data?.otherDataMaps || []).map((obj) => ({
    ...obj,
    dataType: ADD_CD_TAB_KEYS.OTHER,
  }));
  const items = [...testRecords, ...certificateRecords, ...otherRecords];
  const hasExpiredItem =
    items.filter((obj) => {
      const expiryDate =
        obj?.testData?.expiryDate ||
        obj?.certificateData?.expiryDate ||
        obj?.otherData?.expiryDate ||
        '';
      const tMomentVal = getMomentDate(expiryDate);
      const isExpired =
        !!tMomentVal &&
        tMomentVal
          .clone()
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .isBefore(today);
      return isExpired;
    }).length > 0;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const isCompleted = !!data?.isCompleted;
  const isRequired = !!data?.isMandatory;
  const noData = items.length === 0;
  useEffect(() => {
    if (!!defaultExpand) {
      setIsExpanded(defaultExpand);
    }
  }, [defaultExpand]);

  return (
    <div className={cn(classes.subBlockWrapper, className)}>
      <div className={classes.subHeader}>
        {/* <DotSvg className={classes.subDotIcon} /> */}
        {!simple && (
          <CheckCircle
            className={cn(classes.subCheckIcon, {
              [classes.checked]: isCompleted,
            })}
          />
        )}
        <span className={classes.subHeading}>
          <span>{data?.customName?.name}</span>
          {isRequired && <span>*</span>}
          {hasExpiredItem && <ExpiredIcon />}
        </span>
        {!simple && (
          <span className={classes.subIcons}>
            <ATooltip title="Attach Data to This Requirement" dark>
              <span style={{ display: 'flex' }}>
                <PlusSvg onClick={onAdd} />
              </span>
            </ATooltip>
            <ColumnActions
              color="default"
              className={cn(classes.columnActions)}
              dropdownOverlay={classes.dropdownOverlay}
              items={[
                {
                  key: '1',
                  label: (
                    <>
                      <RenameSvg />
                      <span>Edit</span>
                    </>
                  ),
                  onClick: () => {
                    if (onEdit) onEdit();
                  },
                },
                {
                  key: '2',
                  label: (
                    <>
                      <DuplicateSvg />
                      <span>Duplicate</span>
                    </>
                  ),
                  onClick: () => {
                    if (onDuplicate) onDuplicate();
                  },
                },
                {
                  key: '3',
                  label: (
                    <>
                      <CheckCircle
                        className={cn(classes.checkCircleIcon, {
                          [classes.checked]: !isCompleted,
                        })}
                      />
                      <span>{isCompleted ? 'Mark As Incomplete' : 'Mark As Completed'}</span>
                    </>
                  ),
                  onClick: () => {
                    if (onComplete) onComplete(isCompleted);
                  },
                },
                {
                  key: '4',
                  label: (
                    <>
                      <Trash1Svg />
                      <span>Remove</span>
                    </>
                  ),
                  onClick: () => {
                    if (onRemove) onRemove();
                  },
                },
              ]}
            />
            <ArrowRightIcon
              className={cn(classes.subArrowIcon, {
                [classes.expanded]: isExpanded,
              })}
              onClick={() => {
                setIsExpanded(!isExpanded);
                if (onResetExpandDefault) onResetExpandDefault();
              }}
            />
          </span>
        )}
      </div>
      {isExpanded && !simple && (
        <div className={classes.subContent}>
          {noData ? (
            <span className={classes.subNoContent}>There is no data.</span>
          ) : (
            <div className={classes.subList}>
              {items.map((obj, index) => {
                const expiryDate =
                  obj?.testData?.expiryDate ||
                  obj?.certificateData?.expiryDate ||
                  obj?.otherData?.expiryDate ||
                  '';
                const tMomentVal = getMomentDate(expiryDate);
                const isExpired =
                  !!tMomentVal &&
                  tMomentVal
                    .clone()
                    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                    .isBefore(today);
                const testName = [
                  obj.testData?.citation?.name || '',
                  obj.testData?.testItem?.name || '',
                ]
                  .filter((v) => !!v)
                  .join(': ');
                const certificateName = obj?.certificateData?.certificateType?.name || '';
                const otherName = obj?.otherData?.customComplianceOtherDataType?.name || '';
                const tName = testName || certificateName || otherName || '-';
                return (
                  <div key={`${obj.id}_${index}`}>
                    <span>{ICON_MAPPING[obj.dataType]}</span>
                    <span
                      className={classes.subListText}
                      onClick={() => {
                        if (onViewData) onViewData(obj);
                      }}>
                      {tName}
                    </span>
                    {isExpired && <ExpiredIcon />}
                    <TrashSvg
                      onClick={() => {
                        if (onRemoveDataItem) onRemoveDataItem(obj);
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SubBlock;
